module.exports = __webpack_public_path__ + "static/media/farm-bottoms-bw.881d6469.jpg";